module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Partnership Owner',
          to: {
            path: '/partnership-owner'
          },
        },
        {
          text: _vm.form.id ?
            'Ubah Partnership Owner' :
            'Tambah Partnership Owner',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.form.id ? "Ubah Partnership Owner" : "Tambah Partnership Owner") + "\n    ")]), _vm._v(" "), _c('v-form', {
    ref: "form"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n                " + _vm._s(_vm.form.id ?
    "Ubah Partnership Owner" :
    "Tambah Partnership Owner") + "\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-2",
    staticStyle: {
      "min-width": "0 !important"
    },
    attrs: {
      "depressed": "",
      "rouded": "",
      "small": "",
      "height": "33px",
      "color": "#EC675E"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "color": "white"
    }
  }, [_vm._v("\n                        mdi-delete-outline\n                    ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [
    [_c('div', {
      staticClass: "mb-2 mt-4"
    }, [_c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Nama Partnership Owner *\n                                ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "placeholder": "Nama Partnership Owner",
        "outlined": "",
        "rules": [
          function (v) { return !!v ||
          'Nama partnership owner wajib diisi'; } ]
      },
      model: {
        value: (_vm.form.nama),
        callback: function($$v) {
          _vm.$set(_vm.form, "nama", $$v)
        },
        expression: "form.nama"
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Pimpinan *\n                                ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "placeholder": "Pimpinan",
        "outlined": "",
        "rules": [
          function (v) { return !!v || 'Pimpinan wajib diisi'; } ]
      },
      model: {
        value: (_vm.form.pimpinan),
        callback: function($$v) {
          _vm.$set(_vm.form, "pimpinan", $$v)
        },
        expression: "form.pimpinan"
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Provinsi *\n                                ")]), _vm._v(" "), _c('v-autocomplete', {
      staticClass: "pa-0",
      attrs: {
        "placeholder": "Pilih Provinsi",
        "outlined": "",
        "items": _vm.data_provinsi,
        "rules": [
          function (v) { return !!v || 'Provinsi wajib diisi'; } ],
        "item-text": "nama_provinsi",
        "item-value": "kode_provinsi"
      },
      model: {
        value: (_vm.form.provinsi),
        callback: function($$v) {
          _vm.$set(_vm.form, "provinsi", $$v)
        },
        expression: "form.provinsi"
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Alamat *\n                                ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "placeholder": "Alamat",
        "outlined": "",
        "rules": [
          function (v) { return !!v || 'Alamat wajib diisi'; } ]
      },
      model: {
        value: (_vm.form.alamat),
        callback: function($$v) {
          _vm.$set(_vm.form, "alamat", $$v)
        },
        expression: "form.alamat"
      }
    })], 1)], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("\n                                    Deskripsi *\n                                ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "placeholder": "Deskripsi",
        "outlined": "",
        "maxlength": "255",
        "rules": [
          function (v) { return !!v || 'Deskripsi wajib diisi'; } ]
      },
      model: {
        value: (_vm.form.description),
        callback: function($$v) {
          _vm.$set(_vm.form, "description", $$v)
        },
        expression: "form.description"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-4"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.$router.push('/partnership-owner')
        }
      }
    }, [_vm._v("\n                            Batal\n                        ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          return _vm.submitProcess()
        }
      }
    }, [_vm._v("\n                            Simpan\n                        ")])], 1)]
  ], 2)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44dd927f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/partnership/components/PartnershipOwnerForm.vue
// module id = 2196
// module chunks = 1